export const isValidTextChunk = (chunk, lastChunkIndex) =>
  chunk.text && !chunk.done && chunk.chunkIndex !== undefined && chunk.chunkIndex > lastChunkIndex;

export const updateLastMessage = (setMessages, updates, matcher) => {
  setMessages((prev) => {
    const updated = [...prev];
    const lastMsg = updated[updated.length - 1];
    if (!matcher || matcher(lastMsg)) {
      updated[updated.length - 1] = {...lastMsg, ...updates};
    }
    return updated;
  });
};
